import {
	Dtos,
	SuretyAccountId,
	SuretyAccountUnderwritingId,
	SuretyAccountUnderwritingStatus,
	SuretyType,
} from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import {
	bondRequestPreviewsQueryKey,
	bondRequestsQueryKey,
} from "../../bond-request/bond-request.keys";
import { accountPreviewsQueryKey } from "../../previews/previews.keys";
import { accountLatestUnderwritingQueryKey, accountQueryKey } from "../account.keys";

export const useAdminDeclineAccount = (
	accountId: SuretyAccountId,
	underwritingId: SuretyAccountUnderwritingId | undefined,
) => {
	const queryClient = useQueryClient();
	const { patch } = useRequest();

	const mutation = useMutation({
		mutationFn: async () => {
			if (!underwritingId) return;
			await patch(
				`/v2/admin/surety/accounts/${accountId}/underwritings/${underwritingId}`,
				Dtos.Admin.SuretyAccount.Update.Underwriting.Status.Request.schema.parse({
					suretyType: SuretyType.contract,
					status: SuretyAccountUnderwritingStatus.declined,
				}),
				"none",
			);
		},
		onSuccess: async () => {
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: bondRequestsQueryKey() }),
				queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) }),
				queryClient.invalidateQueries({
					queryKey: accountLatestUnderwritingQueryKey(accountId),
				}),
				queryClient.invalidateQueries({ queryKey: accountPreviewsQueryKey() }),
				queryClient.invalidateQueries({ queryKey: bondRequestPreviewsQueryKey() }),
			]);
		},
	});

	return {
		declineAccount: mutation.mutate,
		declineAccountError: mutation.error,
		declineAccountLoading: mutation.isPending,
		dismissDeclineAccountError: () => {
			mutation.reset();
		},
	};
};
